<template>
  <div class="cmp-plugins-basic_accordion" :class="{ expand: expandState }">
    <div class="basic-accordion" @click="onAccordionToggle">
      <div class="accordion-header">
        <b>{{ accortionTitle }}</b>

        <div class="dt-icon-container">
          <img
            v-if="isLocked === true"
            :src="'static/icons/lock-closed-grey.svg'"
            alt=""
            class="dt-icon"
          />
          <img
            :src="`static/icons/${this.validationIconName}`"
            alt=""
            class="dt-icon"
          />
        </div>
        <i class="arrow"></i>
      </div>

      <div class="accordion-body" @click.stop="">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["accortionTitle", "validationIconName", "expandState", "isLocked"],

  methods: {
    onAccordionToggle: function() {
      this.$emit("clicked", this.expandState);
    }
  }
};
</script>

<style lang="scss">
.cmp-plugins-basic_accordion {
  margin-bottom: 4px;
  &.expand,
  &.opened {
    box-shadow: 0 4px 10px #c8c8c84d;
    .basic-accordion {
      border-color: var(--sprt-85);
      .accordion-header {
        .arrow {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          top: 14px;
        }
      }
      .accordion-body {
        opacity: 1;
        padding: 0 30px 15px;
        max-height: 5000px;
      }
    }
  }
}
.basic-accordion {
  border: 1px solid transparent;
  box-shadow: 0 4px 10px transparent;
  // margin-bottom: 4px;
  .accordion-header {
    background-color: #fff;
    color: #282828;
    padding: 10px 7px 10px 30px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    text-transform: uppercase;

    // .dt-icon{
    //   transition: all 0.3s linear;
    //   transform: rotate(0deg);
    // }
    .arrow {
      transition: all 0.3s linear;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      position: absolute;
      left: 10px;
      top: 17px;
    }
    .dt-icon-container {
      flex-direction: row;
      .dt-icon{
        margin-right: 0;
      }
    }
  }
  .accordion-body {
    opacity: 0;
    max-height: 0;
    padding: 0 30px;
    background-color: #fff;
    overflow: hidden;
    transition: all 0.3s ease;

    .form-group {
      padding-top: 0;
    }
  }

  .arrow {
    border: solid var(--col-d10);
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 3px;
  }
}
</style>
